/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_c9ff6062{display:block}.resizeIsShort_c9ff6062{width:400px}.buttonGroup_c9ff6062{margin-bottom:40px}.buttonGroup_c9ff6062 button{margin-right:20px}.settingsGroup_c9ff6062{padding-top:20px}.itemCountDropdown_c9ff6062{width:180px}\n"}]);
export const root = "root_c9ff6062";
export const resizeIsShort = "resizeIsShort_c9ff6062";
export const buttonGroup = "buttonGroup_c9ff6062";
export const settingsGroup = "settingsGroup_c9ff6062";
export const itemCountDropdown = "itemCountDropdown_c9ff6062";